import type { IconData } from '@stacksjs/iconify-core'

export const strollerSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M29.518 1.772A1.5 1.5 0 0 1 31.001.5q1.826 0 3.39.03c6.75.128 11.895 5.237 12.076 11.97H28.568c.16-4.244.563-7.806.789-9.56a69 69 0 0 1 .149-1.085l.009-.06l.002-.016zM24 41.5a5.5 5.5 0 1 0-11 0a5.5 5.5 0 0 0 11 0m8 0a5.5 5.5 0 1 1 11 0a5.5 5.5 0 0 1-11 0M.5 3a2 2 0 0 1 2-2c2.407 0 4.472.334 5.833.631c1.832.399 3.123 1.85 3.487 3.56A90 90 0 0 1 13.385 15.5H45a1.5 1.5 0 0 1 1.5 1.5c0 3.066-.51 5.962-1.097 8.284c-1.035 4.096-4.512 6.773-8.651 7.007c-2.13.12-4.98.209-8.752.209c-3.771 0-6.621-.09-8.752-.21c-4.14-.233-7.616-2.91-8.651-7.006c-.582-2.304-1.089-5.172-1.097-8.21c-.337-4.66-1.129-8.87-1.593-11.052c-.063-.298-.252-.445-.425-.483A23.8 23.8 0 0 0 2.5 5a2 2 0 0 1-2-2\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default strollerSolid
